<template>
  <div class="center-box">
    <div class="center-sum j-flex">
      <div class="d-column d-aligncnter">
        <div>总人数</div>
        <div class="num">{{ warningNum.headCount }}</div>
      </div>
      <div class="d-column d-aligncnter">
        <div>已处理人数</div>
        <div class="num">{{ warningNum.processedCount }}</div>
      </div>
      <div class="d-column d-aligncnter">
        <div>未处理人数</div>
        <div class="num">{{ warningNum.notProcessedCount }}</div>
      </div>
    </div>
    <div class="circle-bg d-center d-aligncnter">
      <div class="test-bg"></div>
      <div
        class="side-img"
        @mouseenter="currIndex = index"
        v-for="(item, index) in classWarningData"
        :key="'class_' + index"
        :class="getCurrClass(index)"
      >
        <img
          src="@/assets/img/academic/sidered.svg"
          v-if="currIndex == index"
        />
        <img src="@/assets/img/academic/side.svg" v-else />
        <div
          class="box d-aligncnter"
          v-if="currIndex == index"
          :class="index == 1 || index == 2 ? 'show-right' : 'show-left'"
        >
          <img src="@/assets/img/academic/deng.svg" style="margin-left: 16px" />
          <div class="d-column">
            <div class="d-aligncnter" style="margin-left: 16px">
              {{ item.courseName }}类学业预警：{{ item.warningCount }}
              <img class="img-16 ccc" src="@/assets/img/academic/upw.svg" />
            </div>
            <!-- <div class="date">2022-08-10 07:32:46</div> -->
          </div>
        </div>
      </div>
      <!-- <div class="side-img side1" @mouseenter="currIndex = 0">
        <img src="@/assets/img/academic/sidered.svg" v-if="currIndex == 0" />
        <img src="@/assets/img/academic/side.svg" v-else />
        <div
          class="box d-aligncnter"
          v-if="currIndex == 0"
          style="bottom: 136px; left: -103px"
        >
          <img src="@/assets/img/academic/deng.svg" style="margin-left: 16px" />
          <div class="d-column">
            <div class="d-aligncnter" style="margin-left: 16px">
              乒乓球类学业预警：8
              <img class="img-16 ccc" src="@/assets/img/academic/upw.svg" />
            </div>
            <div class="date">2022-08-10 07:32:46</div>
          </div>
        </div>
      </div>
      <div class="side-img side2" @mouseenter="currIndex = 1">
        <img src="@/assets/img/academic/sidered.svg" v-if="currIndex == 1" />
        <img src="@/assets/img/academic/side.svg" v-else />
        <div
          class="box d-aligncnter"
          v-if="currIndex == 1"
          style="bottom: 136px; left: -103px"
        >
          <img src="@/assets/img/academic/deng.svg" style="margin-left: 16px" />
          <div class="d-column">
            <div class="d-aligncnter" style="margin-left: 16px">
              乒乓球类学业预警：8
              <img class="img-16 ccc" src="@/assets/img/academic/upw.svg" />
            </div>
            <div class="date">2022-08-10 07:32:46</div>
          </div>
        </div>
      </div>
      <div class="side-img side3" @mouseenter="currIndex = 2">
        <img src="@/assets/img/academic/sidered.svg" v-if="currIndex == 2" />
        <img src="@/assets/img/academic/side.svg" v-else />
        <div
          class="box d-aligncnter"
          v-if="currIndex == 2"
          style="bottom: -80px; left: -188px"
        >
          <img src="@/assets/img/academic/deng.svg" style="margin-left: 16px" />
          <div class="d-column">
            <div class="d-aligncnter" style="margin-left: 16px">
              乒乓球类学业预警：8
              <img class="img-16 ccc" src="@/assets/img/academic/upw.svg" />
            </div>
            <div class="date">2022-08-10 07:32:46</div>
          </div>
        </div>
      </div>
      <div class="side-img side4" @mouseenter="currIndex = 3">
        <img src="@/assets/img/academic/sidered.svg" v-if="currIndex == 3" />
        <img src="@/assets/img/academic/side.svg" v-else />
        <div
          class="box d-aligncnter"
          v-if="currIndex == 3"
          style="bottom: -85px"
        >
          <img src="@/assets/img/academic/deng.svg" style="margin-left: 16px" />
          <div class="d-column">
            <div class="d-aligncnter" style="margin-left: 16px">
              乒乓球类学业预警：8
              <img class="img-16 ccc" src="@/assets/img/academic/upw.svg" />
            </div>
            <div class="date">2022-08-10 07:32:46</div>
          </div>
        </div>
      </div> -->
      <!-- 百分比 -->
      <div class="center-img float-up-down">
        <img src="@/assets/img/academic/center.svg" />
        <div class="centerNum d-aligncnter d-center">{{ percent }}</div>
        <div class="process">
          <process-circle :mypercent="mypercent"></process-circle>
        </div>
      </div>
      <!-- <div class="box d-aligncnter">
        <img src="@/assets/img/academic/deng.svg" style="margin-left: 16px" />
        <div class="d-column">
          <div class="d-aligncnter" style="margin-left: 16px">
            乒乓球类学业预警：8
            <img class="img-16 ccc" src="@/assets/img/academic/upw.svg" />
          </div>
          <div class="date">2022-08-10 07:32:46</div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import ProcessCircle from './ProcessCircle.vue'
export default {
  components: {
    ProcessCircle,
  },
  props: ['percent', 'classWarningData', 'warningNum'],
  data() {
    return {
      mypercent: 70,
      currIndex: 0,
    }
  },
  created() {
    this.mypercent = this.percent
    console.log('classWarningData:', this.classWarningData)
    console.log('warningNum:', this.warningNum)
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.currIndex < 3) {
        this.currIndex++
      } else {
        this.currIndex = 0
      }
    }, 10000)
  },
  computed: {
    getCurrClass() {
      return function (index) {
        console.log("'side' + (index + 1):", 'side' + (index + 1))
        return 'side' + (index + 1)
      }
    },
  },
  methods: {},
}
</script>
<style scoped lang="scss">
.center-sum {
  width: 60%;
  margin-left: 20%;
  font-size: 0.4rem;
  margin-top: 24px;
  .num {
    font-size: 0.5rem;
    color: #00b371;
    font-weight: 600;
  }
}
.center-box {
  width: 100%;
  height: calc(66vh - 0px);
}
.circle-bg {
  width: 100%;
  height: 100%;
  margin-top: 5vh;
  //   background: url('../../../assets/img/academic/circlebg.png') no-repeat;
  //   background-size: 100%;
  //   background-position: center;
  position: relative;
}
.test-bg {
  width: 100%;
  height: 100%;
  margin-top: -5vh;
  position: absolute;
  background: url('../../../assets/img/academic/circlebg.png') no-repeat;
  background-size: 100%;
  background-position: center;
  z-index: 0;
  //   animation: myrotate 1.6s linear infinite;
}
@keyframes myrotate {
  0% {
    transform: rotate(72deg);
  }
  25% {
    transform: rotate(144deg);
  }
  50% {
    transform: rotate(216deg);
  }
  75% {
    transform: rotate(288deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.side-img {
  position: absolute;
  z-index: 99;
}
.side1 {
  top: 16%;
  left: 5%;
}
.side2 {
  top: 16%;
  right: 5%;
}
.side3 {
  top: 53%;
  right: 5%;
}
.side4 {
  top: 53%;
  left: 5%;
}
.center-img {
  //   position: absolute;
  margin-top: -20%;
  position: relative;
  .centerNum {
    font-size: 0.7rem;
    position: absolute;
    width: 128px;
    height: 128px;
    background: radial-gradient(
      69.92% 69.92% at 81.64% 25.78%,
      #007a4d 0%,
      rgba(0, 122, 77, 0.1) 100%
    );
    border-radius: 50%;
    top: -108px;
  }
}
.process {
  position: absolute;
  width: 128px;
  height: 128px;
  top: -108px;
}
.box {
  //   width: 336px;
  width: 6.5rem;
  height: 96px;

  background: linear-gradient(
    90deg,
    rgba(0, 95, 49, 0.5) 0%,
    rgba(0, 95, 49, 0) 106.99%
  );
  box-shadow: inset 0px 0px 24px rgba(0, 255, 161, 0.2);
  border-radius: 8px;
  position: absolute;
  bottom: 60px;
  left: 60px;
  font-size: 0.35rem;
}
.date {
  color: #007a4d;
  font-size: 0.3rem;
  margin-top: 16px;
  margin-left: 16px;
}
.ccc {
  margin-left: 4px;
}
.float-up-down {
  animation: up-down 1.6s linear infinite;
}
@keyframes up-down {
  25% {
    transform: translateY(-4px);
  }
  50%,
  100% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(4px);
  }
}
.show-right {
  top: 100px;
  left: -4.5rem;
}
.show-left {
  top: 100px;
  left: 50px;
}
</style>
